/** The id of the palette's option at a position, for its field's aria-activedescendant. */
export function searchOptionId(listId: string, index: number) {
    return `${listId}-option-${index}`;
}
